import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiResponse } from '@core/interface/api-response.interface';
import { PageableResponse } from '@core/interface/pageable.interface';
import { RefId } from '@core/interface/ref-id.interface';
import { UrlBuilder } from '@core/model/url-builder';
import { ManagementWebhookResponseDto } from '@domain/management-webhook/dtos/management-webhook.response.dto';
import { CreateManagementWebhookRequestDto } from '@domain/management-webhook/dtos/create-management-webhook.request.dto';
import { ListManagementWebhookRequestDto } from '@domain/management-webhook/dtos/list-management-webhook.request.dto';
import { UpdateManagementWebhookRequestDto } from '@domain/management-webhook/dtos/update-management-webhook.request.dto';
import { UpdateStateManagementWebhookRequestDto } from '@domain/management-webhook/dtos/update-state-management-webhook.request.dto';

@Injectable({
    providedIn: 'root',
})
export class ManagementWebhookService extends UrlBuilder {
    constructor(private http: HttpClient) {
        super('management/webhook');
    }

    create(request: CreateManagementWebhookRequestDto) {
        const queryUrl = `${this.getApiUrl()}`;
        return this.http.post<ApiResponse<ManagementWebhookResponseDto>>(
            queryUrl,
            request,
        );
    }

    update(request: UpdateManagementWebhookRequestDto) {
        const { refId } = request;
        const queryUrl = `${this.getApiUrl()}/${refId}`;
        return this.http.put<ApiResponse<ManagementWebhookResponseDto>>(
            queryUrl,
            request,
        );
    }

    updateState(request: UpdateStateManagementWebhookRequestDto) {
        const { refId } = request;
        const queryUrl = `${this.getApiUrl()}/${refId}/state`;
        return this.http.patch<ApiResponse<ManagementWebhookResponseDto>>(
            queryUrl,
            request,
        );
    }

    show(request: RefId) {
        const { refId } = request;
        const queryUrl = `${this.getApiUrl()}/show/${refId}`;
        return this.http.get<ApiResponse<ManagementWebhookResponseDto>>(queryUrl, {});
    }

    list(request: ListManagementWebhookRequestDto) {
        const queryUrl = `${this.getApiUrl()}/list`;
        return this.http.get<
            ApiResponse<PageableResponse<ManagementWebhookResponseDto>>
        >(queryUrl, { params: { ...request } });
    }
}